<ngx-loading [show]="loading || saving" [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }"></ngx-loading>
<div class="wrapper">
  <app-sidebar></app-sidebar>
  <app-header></app-header>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
        <div class="ps-3"><nav aria-label="breadcrumb"><ol class="breadcrumb mb-0 p-0">
          <li class="breadcrumb-item"><a routerLink="/dashboard"><i class="bx bx-home-alt"></i></a></li>
          <li class="breadcrumb-item active" aria-current="page">Web Media</li>
        </ol></nav></div>
      </div>

      <div class="media-page-heading mb-4">
        <h4 class="mb-1">Web Media Management</h4>
        <p class="mb-0">Configure the independent Dashboard and FAQ media locations.</p>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="row g-4">
        <div class="col-12 col-xl-6">
          <div class="card media-card h-100"><div class="card-body p-4">
            <h5 class="card-title">Bunny Stream videos</h5>
            <p class="text-muted small">Paste the Bunny Stream video GUID for each location. Do not reuse an ID unless that is intentional.</p>
            <label class="form-label" for="dashboardVideoId">Dashboard video ID</label>
            <input id="dashboardVideoId" class="form-control mb-3" [(ngModel)]="dashboardVideoId" placeholder="Bunny video GUID">
            <label class="form-label" for="faqHeroVideoId">FAQ hero video ID</label>
            <input id="faqHeroVideoId" class="form-control" [(ngModel)]="faqHeroVideoId" placeholder="Bunny video GUID">
          </div></div>
        </div>

        <div class="col-12 col-xl-6">
          <div class="card media-card h-100"><div class="card-body p-4">
            <h5 class="card-title">FAQ hero image banner</h5>
            <p class="text-muted small">Recommended: a 2.4:1 desktop/tablet banner (for example, 2400 × 1000 px). Any resolution is fine at that ratio; mobile uses 16:9 and may crop the sides.</p>
            <div class="banner-preview" *ngIf="bannerPreview; else noBanner"><img [src]="bannerPreview" alt="Current FAQ banner preview"></div>
            <ng-template #noBanner><div class="banner-empty">No FAQ banner image configured.</div></ng-template>
            <div class="d-flex flex-wrap gap-2 mt-3">
              <label class="btn custom-btn gradient1-btn mb-0" for="bannerImage">Choose image</label>
              <input id="bannerImage" class="d-none" type="file" accept="image/jpeg,image/png,image/webp,image/gif" (change)="onBannerSelected($event)">
              <button type="button" class="btn btn-outline-danger" *ngIf="bannerPreview" (click)="clearBanner()">Remove image</button>
            </div>
            <small class="text-muted d-block mt-2">JPG, PNG, WEBP or GIF.</small>
          </div></div>
        </div>

        <div class="col-12">
          <div class="card media-card"><div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
              <div><h5 class="card-title mb-1">FAQ video carousel</h5><p class="text-muted small mb-3">The reusable carousel supports up to 6 independent Bunny Stream videos. Three empty starter slots are provided; add the final Bunny IDs later.</p></div>
              <button type="button" class="btn custom-btn gradient1-btn carousel-add-button" (click)="addCarouselItem()" [disabled]="carouselItems.length >= 6">Add video</button>
            </div>
            <div class="carousel-items">
            <div class="carousel-row" *ngFor="let item of carouselItems; let i = index">
              <div class="carousel-number">{{ i + 1 }}</div>
              <div class="flex-grow-1 row g-2">
                <div class="col-12 col-lg-4"><label class="form-label">Bunny video ID</label><input class="form-control" [(ngModel)]="item.bunnyVideoId" placeholder="Required GUID"></div>
                <div class="col-12 col-lg-4"><label class="form-label">Title</label><input class="form-control" [(ngModel)]="item.title" placeholder="Video title"></div>
                <div class="col-12 col-lg-4"><label class="form-label">Description</label><input class="form-control" [(ngModel)]="item.description" placeholder="Optional description"></div>
                <div class="col-12 col-lg-8"><label class="form-label">Tags</label><input class="form-control" [(ngModel)]="item.tags" placeholder="Optional, comma-separated"></div>
                <div class="col-12 col-lg-4 d-flex align-items-end"><label class="form-check mb-2"><input class="form-check-input" type="checkbox" [(ngModel)]="item.active"> <span class="form-check-label">Visible on FAQ</span></label></div>
              </div>
              <div class="carousel-actions">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="moveCarouselItem(i, -1)" [disabled]="i === 0" aria-label="Move video up">↑</button>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="moveCarouselItem(i, 1)" [disabled]="i === carouselItems.length - 1" aria-label="Move video down">↓</button>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeCarouselItem(i)" aria-label="Remove video">Remove</button>
              </div>
            </div>
            </div>
            <div class="banner-empty" *ngIf="!carouselItems.length">No carousel slots configured. Use “Add video” to create a slot.</div>
            <div class="form-btn-box pt-4"><button type="button" class="btn custom-btn gradient1-btn px-5" (click)="save()" [disabled]="saving">Save media settings</button></div>
          </div></div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
